/**
 * Kontrast nach WCAG 2.x — für die Akzentfarbe des Kontos (docs/21, Pro).
 *
 * Die Akzentfarbe ersetzt das Rot der App, also auch den Grund der
 * Hauptknöpfe. Deren Schrift war fest fast schwarz: Mit einem dunklen Blau
 * als Akzent war „Speichern" nicht mehr zu lesen. Jetzt wird die Schrift je
 * Farbe hell oder dunkel gewählt — was sich stärker abhebt.
 */
const HEX = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;

/** Relative Leuchtdichte 0…1; `null` bei ungültiger Farbe (nur `#rrggbb`) */
export function leuchtdichte(farbe: string): number | null {
  const m = HEX.exec(farbe);
  if (!m) return null;
  const [r, g, b] = [m[1], m[2], m[3]].map((x) => {
    const c = parseInt(x as string, 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** Kontrastverhältnis 1…21; 0 bei ungültiger Farbe */
export function kontrast(a: string, b: string): number {
  const la = leuchtdichte(a);
  const lb = leuchtdichte(b);
  if (la === null || lb === null) return 0;
  const [hell, dunkel] = la > lb ? [la, lb] : [lb, la];
  return (hell + 0.05) / (dunkel + 0.05);
}

/** Schrift auf den Knöpfen der App: fast schwarz wie im Mockup, oder weiß */
export const SCHRIFT_DUNKEL = '#17090a';
export const SCHRIFT_HELL = '#ffffff';

/** Die Knopfschrift, die sich von `grund` stärker abhebt */
export function schriftAuf(grund: string): string {
  return kontrast(grund, SCHRIFT_DUNKEL) >= kontrast(grund, SCHRIFT_HELL) ? SCHRIFT_DUNKEL : SCHRIFT_HELL;
}

/** Hintergründe der beiden Themes (index.css: --color-panel) — gegen sie steht die Farbe als Text */
const FLAECHEN = ['#151c20', '#ffffff'] as const;

/**
 * Taugt die Farbe auch als Schrift (Marken, Ränge, Links in Akzentfarbe)?
 * Unter 3:1 gegen einen der beiden Hintergründe verschwindet sie dort.
 */
export function alsSchriftLesbar(farbe: string): boolean {
  return FLAECHEN.every((f) => kontrast(farbe, f) >= 3);
}
